import { TASK_STATUS, /* isToPDF */ } from "Api/constants";

/**
 * @typedef {Object} Task
 * @property {Object} data
 * @property {FileData} data.fileData
 * @property {Number} percent The progress of upload file
 * @property {Number} id
 * @property {String} docid From server 
 * @property {Boolean} isCancel check task status 
 * @property {Function} onMessage To receive message
 * @property {Function} cancel To cancel task
 * @property {Function} start To call default function
 * @property {Function} clearData To call default function
 */
let localTaskIndex = 1;
/** 
 * @param {Object} data
 * @param {Function} fn
 * 
 */
export function Task(data, fn) {
    let _this = this;
    this.percent = 0;
    this.data = data;
    this.id = localTaskIndex++;
    this.status = TASK_STATUS.WAITING;
    this.cancelSource = null;
    this.docid = null;
    this.clearData = ()=>{
        _this.data && _this.data.fileData && _this.data.fileData.clean && _this.data.fileData.clean();
    }
    this.onMessage = ({type, percent, docid})=>{
        _this.status = type;
        _this.percent = percent;
        _this.docid = !!docid?docid:null;
    }
    this.setCancelSource = (source)=>{
        _this.cancelSource = source;
    }
    this.cancel = (message)=>{
        _this.cancelSource && _this.cancelSource.cancel(message);
        _this.status = TASK_STATUS.CANCEL;
    }
    this.isCancel = this.status === TASK_STATUS.CANCEL;
    //this.callback = callback;
    this.start = ()=>{
        fn(this.data, this)
    }
    return this;
}